import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStyles } from "../styles";
import Stack from "@mui/material/Stack";

//assets
import NoBackground from "../../../assets/background/no-img.png";
import Button from "@mui/material/Button";
import { Autocomplete } from "../../../components/Autocomplete";
import TextField from "@mui/material/TextField";

type DescriptionProps = {
  expanded?: boolean;
  onChange?: (isExpanded: boolean) => void;
};

export function Description({ expanded, onChange }: DescriptionProps) {
  const styles = useStyles();

  return (
    <Accordion
      expanded={expanded}
      elevation={0}
      className={styles.rootAccordion}
      onChange={(_, isExpanded) => (onChange ? onChange(isExpanded) : {})}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography>Descrição</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={4} direction="row" alignItems="center">
          <Stack spacing={3}>
            <Typography variant="body2" color="GrayText">
              As informações da loja selecionada aparecerão na sua imagem. Por
              exempo: logo, endereço e número de telefone.
            </Typography>
            <Autocomplete
              fullWidth
              size="small"
              label="Lojas"
              placeholder="Selecione a loja"
              options={[]}
              getOptionLabel={(option) => option.name}
            />
            <TextField size="small" label="Endereço" />
            <TextField size="small" label="Celular" />
            <TextField
              size="small"
              label="Descrição"
              helperText="Exemplo: Ofertas válidas somente este final de semana!"
            />
            <Stack direction="row" spacing={4}>
              <Button size="small" color="inherit">
                Cancelar
              </Button>
              <Button size="small" variant="contained">
                Salvar
              </Button>
            </Stack>
          </Stack>
          <Stack spacing={1}>
            <img
              className={styles.imgStore}
              src={NoBackground}
              alt="preview-store"
            />
            <Button size="small">Adicionar logo</Button>
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
